"use client";

import { useLayoutEffect, useState } from "react";

function getGridColumns(): number {
  if (typeof window === "undefined") {
    return 3;
  }

  if (window.matchMedia("(min-width: 1280px)").matches) {
    return 3;
  }

  if (window.matchMedia("(min-width: 768px)").matches) {
    return 2;
  }

  return 1;
}

export function useGridColumns(): number {
  const [columns, setColumns] = useState(getGridColumns);

  useLayoutEffect(() => {
    const updateColumns = () => {
      setColumns(getGridColumns());
    };

    updateColumns();
    window.addEventListener("resize", updateColumns);

    return () => {
      window.removeEventListener("resize", updateColumns);
    };
  }, []);

  return columns;
}

export function chunkIntoRows<T>(items: T[], columns: number): T[][] {
  const rows: T[][] = [];

  for (let index = 0; index < items.length; index += columns) {
    rows.push(items.slice(index, index + columns));
  }

  return rows;
}
